<template>
  <!-- PSG解析結果入力 -->
  <div id="PSGAnalyisisResult">
    <div id="container">
      <psgNavi v-bind:pageid='"PSGAnalyisisResult"'></psgNavi>
      <div class="labelTitle lable">PSG解析 結果入力</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber" maxlength="20"/></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
                <option></option>
                <option value="1">フルPSG検査</option>
                <option value="2">簡易検査</option>
                <option value="3">睡眠検査機器配送ｻｰﾋﾞｽ</option>
              </select>
            </td>
            <th>デモ</th>
            <td><select v-model="searchConditions.demo">
                <option></option>
                <option value="false">含まない</option>
                <option value="true">デモのみ</option>
              </select>
            </td>
            <th>解析方法</th>
            <td><select v-model="searchConditions.analysisMethod">
              <option v-for="method in analysisMethodList" :value="method.value" :key="method.value">{{ method.label1 }}</option>
            </select></td>
          </tr>
          <tr>
            <th style="font-size: 10px">いびきセンサー</th>
            <td><select v-model="searchConditions.snoreSensor">
              <option></option>
              <option value="1">無</option>
              <option value="2">有</option>
            </select></td>
            <th>依頼元</th>
            <td><input type="text" v-model="searchConditions.client" maxlength="256"/></td>
            <th>医療機関</th>
            <td><input type="text" v-model="searchConditions.hospital" maxlength="256"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName" maxlength="100"/></td>
          </tr>
          <tr>
            <th>解析担当者</th>
            <td><input type="text" v-model="searchConditions.analysisStaffName" maxlength="100"/></td>
          </tr>
          <tr>
            <th>返却希望日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.returnDeadlineStart"/> ～ <input type="date" v-model="searchConditions.returnDeadlineEnd"/></td>
            <th>解析期限</th>
            <td colspan="3"><input type="date" v-model="searchConditions.analysisDeadlineStart"/> ～ <input type="date" v-model="searchConditions.analysisDeadlineEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult" >
        <span class="result-count">件数：{{data.length}}件</span>
        <b-table
          id="psgAnalyisisResultTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="receiptNumber" label="受付番号" width="80" sortable centered>
              <router-link :to="{name:'PSGAnalyisisResultDetail', params:{item:props.row, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column field="returnDeadline" label="返却希望日" width="100" sortable centered>
              {{props.row.returnDeadline }}<span v-if="props.row.urgent" class="urgent" />
            </b-table-column>
            <b-table-column field="analysisDeadline" label="解析期限" width="100" sortable centered>
              {{props.row.analysisDeadline }}
            </b-table-column>
            <b-table-column field="kind" label="種別" width="80" sortable >
              {{props.row.kind}}<span v-if="props.row.demo" class="demo" />
            </b-table-column>
            <b-table-column field="analysisMethod" label="解析方法" width="180" sortable>
              {{props.row.analysisMethod | analysisMethodFilter(analysisMethodList)}}
            </b-table-column>
            <b-table-column field="snoreSensor" label="いびきセンサー" width="80" sortable>
              {{props.row.snoreSensor | snoreSensorFilter()}}
            </b-table-column>
            <b-table-column field="client" label="依頼元" width="200" sortable>
              {{props.row.client}}
            </b-table-column>
            <b-table-column field="hospital" label="医療機関" width="200" sortable>
              {{props.row.hospital}}
            </b-table-column>
            <b-table-column field="patientName" label="患者名" width="150" sortable>
              {{props.row.patientName}}
            </b-table-column>
            <b-table-column field="analysisStaffName" label="解析担当者" width="150" sortable>
              {{props.row.analysisStaffName}}
            </b-table-column>
            <b-table-column field="status" label="状態" width="150" sortable class="emphasis">
              <span :class="getTabClass4InternalStatus(props.row.status)">
              {{getStatus(props.row.status)}}
              </span>
            </b-table-column>
            <b-table-column field="file" label="" width="20">
              <a @click="showReportArea(props.row.analysisResultFileList)">
              <b-icon icon="clipboard-file-outline" /></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
      <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="450" height="300" top="100px" right="100px">
        <downLoadFileList :fileList="fileListStr" :showNoteFlg="true" />
      </floatingModal>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import DownLoadFileList from "@/components/mock/common/DownLoadFileList";
import naviBar from "@/components/mock/philips/psg/PSGNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

var data = [];
export default {
  name: "PSGAnalyisisResult",
  methods: {
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getPsgAnalysisResultListPOST;
      var successCallBack = this.getPsgAnalysisResultListPOSTSuccess;
      var errorCallBack = this.getPsgAnalysisResultListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPsgAnalysisResultListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalPsg.getPsgAnalysisResultListPOST({
        body:obj
      });
    },
    getPsgAnalysisResultListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getPsgAnalysisResultListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.analysisMethodList = this.getChoiceList(this.choicesType.psgMethod, false);
      this.analysisMethodList.unshift({})
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
    closeFileArea: function(){
      this.$modal.hide('detail-modal')
    },
    showReportArea: function(fileList) {
      this.fileListStr = fileList;
      this.$modal.show('detail-modal')
    },

  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var def_analysisStaffName = userInfo.lastName + " " + userInfo.firstName;
    return {
      searchConditions:{
        receiptNumber:"",
         client:"",
         hospital:"",
         patientName:"",
         analysisStaffName: def_analysisStaffName,
         kind:"",
         demo: "",
         analysisMethod:"",
         returnDeadlineStart:"",
         returnDeadlineEnd:"",
         analysisDeadlineStart:"",
         analysisDeadlineEnd:"",
      },
      choicesType:choicesType,
      data: [],
      isPaginated: true,
      analysisMethodList:[],
      takeOverSearchParams,
      hasResult: false,
      fileListStr:"",
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    analysisMethodFilter(value, analysisMethodList){
      var target = analysisMethodList.find(val => val.value == value)
      if(target){
        return target.label1
      }
      return ""
    },  
    snoreSensorFilter(value){
      if (value == "1") {
        return "無"
      } else if (value == "2") {
        return "有"
      } else {
        return "-"
      }
    },
  },
  components: {
    psgNavi: naviBar,
    floatingModal:floatingModal,
    downLoadFileList:DownLoadFileList
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/psg/PSGAnalyisisResult.vue